export const ImgRoute = {
  computeManual: require('assets/image/compute-manual.png'),
  computeDate: require('assets/image/compute-date.png'),
  computeDateadd: require('assets/image/compute-dateadd.png'),
  computeDatediff: require('assets/image/compute-datediff.png'),
  computeDateValue: require('assets/image/compute-datevalue.png'),
  computeDateFormat: require('assets/image/compute-dateformat.png'),
  computeDatetrunc: require('assets/image/compute-datetrunc.png'),
  computeDay: require('assets/image/compute-day.png'),
  computeDayOfWeek: require('assets/image/compute-dayofweek.png'),
  computeDayOfYear: require('assets/image/compute-dayofyear.png'),
  computeEndOfMonth: require('assets/image/compute-endofmonth.png'),
  computeHour: require('assets/image/compute-hour.png'),
  computeNow: require('assets/image/compute-now.png'),
  computeQuarter: require('assets/image/compute-quarter.png'),
  computeWeekOfYear: require('assets/image/compute-weekofyear.png'),
  computeYaer: require('assets/image/compute-year.png'),
  computeSecond: require('assets/image/compute-second.png'),
  computeMonth: require('assets/image/compute-month.png'),
  computeMinute: require('assets/image/compute-minute.png'),
  computeToday: require('assets/image/compute-today.png'),
  computeIsBlank: require('assets/image/compute-isblank.png'),
  computeIsNumber: require('assets/image/compute-isnumber.png'),
  computeIsText: require('assets/image/compute-istext.png'),
  computeAnd: require('assets/image/compute-and.png'),
  computeIf: require('assets/image/compute-if.png'),
  computeIfError: require('assets/image/compute-iferror.png'),
  computeNot: require('assets/image/compute-not.png'),
  computeOr: require('assets/image/compute-or.png'),
  computeAbs: require('assets/image/compute-abs.png'),
  computePower: require('assets/image/compute-power.png'),
  computeMidnight: require('assets/image/compute-midnight.png'),
  computeMindate: require('assets/image/compute-mindate.png'),
  computeIsDate: require('assets/image/compute-isdate.png'),
  computeIsNull: require('assets/image/compute-isnull.png'),
  computeCeiling: require('assets/image/compute-ceiling.png'),
  computeExp: require('assets/image/compute-exp.png'),
  computeFloor: require('assets/image/compute-floor.png'),
  computeInt: require('assets/image/compute-int.png'),
  computeLn: require('assets/image/compute-ln.png'),
  computeMod: require('assets/image/compute-mod.png'),
  computeLog10: require('assets/image/compute-log10.png'),
  computeRound: require('assets/image/compute-round.png'),
  computeRoundDown: require('assets/image/compute-rounddown.png'),
  computeRoundUp: require('assets/image/compute-roundup.png'),
  computeSign: require('assets/image/compute-sign.png'),
  computeSqrt: require('assets/image/compute-sqrt.png'),
  computeSum: require('assets/image/compute-sum.png'),
  computeAverage: require('assets/image/compute-average.png'),
  computeMax: require('assets/image/compute-max.png'),
  computeMin: require('assets/image/compute-min.png'),
  computeChar: require('assets/image/compute-char.png'),
  computeConcatenate: require('assets/image/compute-concatenate.png'),
  computeFind: require('assets/image/compute-find.png'),
  computeLeft: require('assets/image/compute-left.png'),
  computeLen: require('assets/image/compute-len.png'),
  computeLower: require('assets/image/compute-lower.png'),
  computeMid: require('assets/image/compute-mid.png'),
  computePadLeft: require('assets/image/compute-padleft.png'),
  computePadRight: require('assets/image/compute-padright.png'),
  computeRegExp: require('assets/image/compute-regexp.png'),
  computeRegexpExtract: require('assets/image/compute-regexpextract.png'),
  computeRegexpReplace: require('assets/image/compute-regexpreplace.png'),
  computeReplace: require('assets/image/compute-replace.png'),
  computeReverse: require('assets/image/compute-reverse.png'),
  computeRight: require('assets/image/compute-right.png'),
  computeStr: require('assets/image/compute-str.png'),
  computeTrim: require('assets/image/compute-trim.png'),
  computeTrimLeft: require('assets/image/compute-trimleft.png'),
  computeTrimRight: require('assets/image/compute-trimright.png'),
  computeUpper: require('assets/image/compute-upper.png'),
  computeValue: require('assets/image/compute-value.png'),
  computeSearch: require('assets/image/compute-search.png'),
};
